import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';

function AssociationTable({ triplets }) {
    if (!triplets || !Array.isArray(triplets)) {
      return <div>No data available</div>;
    }
    
    // 按照score从大到小排序
    const sortedTriplets = [...triplets].sort((a, b) => b.score - a.score);
    // 排序后的去重
    const uniqueTriplets = [...new Map(sortedTriplets.map(item => [
      `${item.entity_one_id}-${item.entity_two_id}-${item.relation_name}-${item.pmid}`,
      item
    ])).values()];
  
    return (
      <TableContainer component={Paper} sx={{ maxHeight: 440, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Entity One ID</TableCell>
              <TableCell>Entity One</TableCell>
              <TableCell>Entity One Type</TableCell>
              <TableCell>Entity Two ID</TableCell>
              <TableCell>Entity Two</TableCell>
              <TableCell>Entity Two Type</TableCell>
              <TableCell>Relation Type</TableCell>
              <TableCell>Score</TableCell>
              <TableCell>PubMed ID</TableCell>
              <TableCell>Sentence</TableCell>
              <TableCell>Author</TableCell>
              <TableCell>Publication Year</TableCell>
              <TableCell>Publication Type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {uniqueTriplets.map((association, index) => {
              return (
                <TableRow key={index} hover>
                  <TableCell>{association.entity_one_id}</TableCell>
                  <TableCell>{association.entity_one_name}</TableCell>
                  <TableCell>{association.entity_one_type}</TableCell>
                  <TableCell>{association.entity_two_id}</TableCell>
                  <TableCell>{association.entity_two_name}</TableCell>
                  <TableCell>{association.entity_two_type}</TableCell>
                  <TableCell>{association.relation_name}</TableCell>
                  <TableCell>{association.score}</TableCell>
                  <TableCell>{association.pmid}</TableCell>
                  <TableCell>
                    <Tooltip title={association.sentance || ''}>
                      <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {association.sentance}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={association.article_authors || ''}>
                      <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {association.article_authors}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={association.article_publication_year || ''}>
                      <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {association.article_publication_year}
                      </div>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={association.article_publication_type || ''}>
                      <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {association.article_publication_type}
                      </div>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

export default AssociationTable;